import { createTheme, Theme } from '@mui/material/styles';

// Create base theme with forced-colors support
const createBaseTheme = (mode: 'light' | 'dark'): Theme => createTheme({
  palette: {
    mode,
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      default: mode === 'dark' ? '#121212' : '#ffffff',
      paper: mode === 'dark' ? '#1e1e1e' : '#f5f5f5',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@media (forced-colors: active)': {
          '*': {
            // Use Windows system colors in forced colors mode
            backgroundColor: 'Canvas',
            color: 'CanvasText',
            borderColor: 'CanvasText',
            // Ensure proper contrast
            forcedColorAdjust: 'auto',
          },
          // Override specific elements
          'a:link': { color: 'LinkText' },
          'a:visited': { color: 'VisitedText' },
          'a:hover': { color: 'ActiveText' },
          'button, [role="button"]': {
            borderColor: 'ButtonBorder',
            backgroundColor: 'ButtonFace',
            color: 'ButtonText',
          },
          // Ensure icons remain visible
          'svg': {
            forcedColorAdjust: 'auto',
          },
        },
      },
    },
  },
});

export const darkTheme = createBaseTheme('dark');
export const lightTheme = createBaseTheme('light'); 